export class CustomPermitModel {
  id = '0';
  singularName = '';
  pluralName = '';
  sourceReasonId = '0';
  clock = 'y';
  reconsider = 'n';
  goodwillCancellations = '0';
  misuseOption = '0';
  signpostOption = '0';
  myOwnExplanation = '';
}
